/*
  V2 · Búsqueda que entiende la fiesta o el negocio (pedido de Boris, 12/10/2026).

  El cliente escribe como habla («cumple de 7, le gusta el fútbol», «un cartel para guardar de noche»).
  La página saca de ahí la ocasión, la edad, la temática y el uso, y propone pocas opciones con sus
  diseños reales. Siempre cierra con los mensajes que empujan: diseño a medida sin costo, seña del 50 %
  y cuotas con Mercado Pago.

  No inventa nada: las temáticas y los diseños salen de assets/v2-temas.json, los productos y precios
  de la tienda, y las recomendaciones por situación son las mismas de «¿Qué celebrás?» y «¿Qué necesitás?».

  Se monta sobre cualquier <form data-tm-busca> (ver sections/busca-inteligente.liquid) y sobre la página
  de resultados de búsqueda.
*/

/* Núcleo sin DOM: interpreta el texto. Se prueba con Node (tests/theme/busca.test.js). */
function tmBuscaNucleo(datos) {
  function normalizar(texto) {
    return String(texto || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function raiz(palabra) { return palabra.length > 3 ? palabra.replace(/s$/, '') : palabra; }

  var OCASIONES = [
    { id: 'quince', nombre: '15 años', claves: ['quince', 'quinceanera', 'quinceanero', 'xv'],
      productos: ['kit-15-anos-mural-de-firmas', 'pasacalles-quinceaneras', 'mural-de-firmas'], tema: 'quince' },
    { id: 'egresados', nombre: 'Egresados', claves: ['egresado', 'egresada', 'egreso', 'graduacion', 'recibida', 'recibio', 'recibi'],
      productos: ['pasacalles-egresados', 'marco-selfie', 'mural-de-firmas'], tema: 'egresados' },
    { id: 'baby', nombre: 'Baby shower', claves: ['baby', 'shower', 'nacimiento', 'embarazo', 'embarazada'],
      productos: ['pasacalles-babyshower-1', 'fondos-rigidos-circulares', 'figuras-de-cumpleanos'], tema: 'bebe' },
    { id: 'bienvenida', nombre: 'Bienvenida', claves: ['bienvenida', 'bienvenido', 'vuelve', 'vuelven', 'regreso', 'aeropuerto'],
      productos: ['pasacalles-bienvenida-1'], tema: '' },
    { id: 'amor', nombre: 'Aniversario o declaración', claves: ['aniversario', 'casamiento', 'boda', 'novia', 'novio', 'amor', 'valentin', 'declaracion'],
      productos: ['pasacalles-romanticos-1', 'marco-selfie', 'mural-de-firmas'], tema: 'romanticos' },
    { id: 'cumple', nombre: 'Cumpleaños', claves: ['cumple', 'cumpleano', 'cumpleanito', 'anito', 'fiesta', 'fiestita', 'festejo'],
      productos: ['pasacalles-cumpleanos', 'kits-de-cumpleanos', 'figuras-de-cumpleanos'], tema: '' }
  ];

  var NEGOCIOS = [
    { id: 'inauguracion', nombre: 'Abro un local', claves: ['inauguro', 'inauguracion', 'inaugurar', 'abro', 'apertura', 'abrimos', 'abrir'],
      productos: ['pack-inauguracion', 'pasacalle', 'cartel-de-vereda'] },
    { id: 'oferta', nombre: 'Tengo una oferta', claves: ['oferta', 'promo', 'promocion', 'liquidacion', 'descuento', 'rebaja'],
      productos: ['pack-emprendedor', 'cartel-de-vereda', 'pizarra-doble-de-piso'] },
    { id: 'feria', nombre: 'Voy a una feria', claves: ['feria', 'evento', 'stand', 'expo', 'exposicion', 'lanzamiento'],
      productos: ['pack-feria', 'roll-up-1', 'banner-x-1'] },
    { id: 'vereda', nombre: 'Algo que saco y guardo', claves: ['vereda', 'guardar', 'guardo', 'sacar', 'saco', 'movil', 'portatil', 'pizarra', 'caballete'],
      productos: ['cartel-de-vereda', 'pizarra-doble-de-piso', 'roll-up-1'] },
    { id: 'luminoso', nombre: 'Busco un luminoso', claves: ['luminoso', 'luz', 'iluminado', 'iluminada', 'led', 'neon', 'noche'],
      productos: ['cartel-luminoso-led', 'cartel-luminoso-led-slim-retroiluminado', 'cartel-lumi-glass'] },
    { id: 'vidriera', nombre: 'Para la vidriera', claves: ['vidriera', 'vidrio', 'ventana', 'esmerilado', 'microperforado'],
      productos: ['vinilos-adhesivos', 'vinilo-microperforado'] },
    { id: 'ploteo', nombre: 'Ploteo y vinilos', claves: ['ploteo', 'plotear', 'vinilo', 'adhesivo', 'calco', 'sticker'],
      productos: ['vinilos-adhesivos', 'vinilo-microperforado', 'iman-vehicular'] },
    { id: 'vehiculo', nombre: 'Para el vehículo', claves: ['auto', 'camioneta', 'vehiculo', 'camion', 'utilitario', 'iman', 'moto'],
      productos: ['iman-vehicular', 'vinilos-adhesivos'] },
    { id: 'fachada', nombre: 'Para el frente del local', claves: ['fachada', 'frente', 'marquesina', 'gigantografia', 'lona'],
      productos: ['lona-impresa', 'cartel-en-sintra', 'cartel-luminoso-led'] },
    { id: 'pared', nombre: 'Para una pared', claves: ['pared', 'empapelar', 'empapelado', 'mural', 'fotomural', 'tapiz'],
      productos: ['papel-tapiz-vinilo', 'vinilos-adhesivos'] },
    { id: 'placa', nombre: 'Placa profesional', claves: ['placa', 'consultorio', 'estudio', 'abogado', 'abogada', 'doctor', 'doctora', 'contador', 'escribano', 'profesional'],
      productos: ['placa-profesional-en-acrilico-personalizada-oro-o-plata', 'letras-corporeas'] }
  ];

  /* Palabras que también nombran una temática (además del nombre propio de cada una). */
  var SINONIMOS = {
    'dinosaurios': ['dino', 'dinosaurio', 'rex', 'jurasico'],
    'futbol-deportes': ['futbol', 'pelota', 'deporte', 'basquet', 'penarol', 'messi', 'rugby'],
    'princesas-hadas': ['princesa', 'hada', 'castillo', 'corona'],
    'unicornios-arcoiris': ['unicornio', 'arcoiris'],
    'superheroes': ['superheroe', 'heroe', 'heroes'],
    'espacio': ['espacio', 'astronauta', 'planeta', 'cohete', 'galaxia'],
    'selva-animales': ['selva', 'safari', 'animal', 'animales', 'animalito', 'leon', 'jirafa', 'tigre'],
    'granja': ['granja', 'vaca', 'tractor', 'gallina'],
    'sirenas-mar': ['sirena', 'mar', 'oceano', 'tiburon', 'pez', 'peces'],
    'autos-vehiculos': ['autito', 'carrera', 'carreras', 'camiones'],
    'videojuegos': ['videojuego', 'gamer', 'jueguito', 'consola'],
    'anime-kpop': ['anime', 'kpop', 'manga'],
    'musica-baile': ['musica', 'baile', 'cantante', 'bailarina', 'ballet'],
    'flores-mariposas': ['flor', 'flores', 'mariposa', 'floral'],
    'bebe': ['bebe', 'bebito', 'bebita'],
    'romanticos': ['romantico', 'romantica'],
    'mickey-minnie': ['mickey', 'minnie'],
    'stitch': ['stitch'],
    'dibujos-cuentos': ['dibujito', 'dibujitos', 'cuento'],
    'munecas-juguetes': ['muneca', 'juguete'],
    'circo-carrusel': ['circo', 'carrusel', 'payaso', 'calesita'],
    'comunion': ['comunion', 'bautismo'],
    'halloween': ['halloween', 'bruja', 'brujas']
  };
  /* Formas de nombrar un personaje que no coinciden con cómo está guardado. */
  var ALIAS = {
    'hombre arana': 'Spiderman', 'spider man': 'Spiderman', 'patrulla canina': 'Paw Patrol', 'zenon': 'La Granja de Zenón',
    'elsa': 'Frozen', 'mario bros': 'Super Mario', 'mario': 'Super Mario', 'sirenita': 'La Sirenita', 'peppa': 'Peppa Pig',
    'mickey': 'Mickey Mouse', 'minnie': 'Minnie Mouse', 'pokemon': 'Pokémon', 'pikachu': 'Pokémon', 'rayo mcqueen': 'Cars',
    'kpop': 'Guerreras K-Pop', 'rey leon': 'El Rey León', 'bob esponja': 'Bob Esponja', 'simpson': 'Los Simpson', 'simpsons': 'Los Simpson'
  };

  /* Palabras de negocio que también se usan hablando de una fiesta: solas no alcanzan para decidir. */
  var AMBIGUAS = ['auto', 'moto', 'noche', 'luz', 'evento', 'mural', 'estudio', 'profesional', 'frente', 'abrir', 'saco', 'sacar', 'guardar', 'guardo'];
  /* Personajes que además son nombres de pila: «cumple de Aurora» no pide una temática. */
  var NOMBRES_DE_PILA = ['angel', 'bella', 'aurora', 'jasmine', 'daisy', 'spirit', 'turbo'];
  var SIN_SENTIDO = ['anos', 'para', 'animados'];

  /* Índice de personajes: nombre normalizado -> { nombre, tema, cantidad }. */
  var personajes = {};
  var porPersonaje = {};
  Object.keys(datos.disenos).forEach(function (clave) {
    var d = datos.disenos[clave];
    if (!d.p) return;
    (porPersonaje[d.p] = porPersonaje[d.p] || { temas: {}, cantidad: 0 }).cantidad++;
    (d.t || []).forEach(function (t) { porPersonaje[d.p].temas[t] = (porPersonaje[d.p].temas[t] || 0) + 1; });
  });
  Object.keys(porPersonaje).forEach(function (nombre) {
    var temas = porPersonaje[nombre].temas;
    var tema = Object.keys(temas).sort(function (a, b) { return temas[b] - temas[a]; })[0] || '';
    var ficha = { nombre: nombre, tema: tema, cantidad: porPersonaje[nombre].cantidad };
    personajes[normalizar(nombre)] = ficha;
    // «Arcane / League of Legends» también se encuentra por cada una de sus partes.
    if (nombre.indexOf('/') >= 0) {
      nombre.split('/').forEach(function (parte) {
        var clave = normalizar(parte);
        if (clave && !personajes[clave]) personajes[clave] = ficha;
      });
    }
  });
  NOMBRES_DE_PILA.forEach(function (n) { delete personajes[n]; });
  Object.keys(ALIAS).forEach(function (alias) {
    var destino = personajes[normalizar(ALIAS[alias])];
    if (destino) personajes[alias] = destino;
  });

  function contiene(palabras, claves) {
    return claves.some(function (clave) {
      return palabras.some(function (p) { return p === clave || raiz(p) === raiz(clave); });
    });
  }

  function interpretar(texto) {
    var limpio = normalizar(texto);
    var palabras = limpio ? limpio.split(' ') : [];
    var conEspacios = ' ' + limpio + ' ';
    var compacto = limpio.replace(/ /g, '');
    var r = { texto: limpio, edad: null, ocasion: null, negocio: null, tema: '', temaPedido: false, personaje: null };
    if (!palabras.length) return r;

    // Edad: «7 años», «cumple de 7», «sus 4». Se ignoran medidas («3 metros», «2x1») y horarios.
    var edad = /(?:^| )(\d{1,2})(?: (?:ano|anos|anito|anitos))?(?= |$)/.exec(limpio);
    if (edad && !/\d ?(?:m|mt|mts|metro|metros|cm|x|hs|hora|horas)(?: |$)/.test(limpio)) {
      var n = +edad[1];
      if (n >= 1 && n <= 99) r.edad = n;
    }

    // Personaje: el nombre más largo que aparezca en el texto.
    Object.keys(personajes).sort(function (a, b) { return b.length - a.length; }).some(function (nombre) {
      var entero = conEspacios.indexOf(' ' + nombre + ' ') >= 0;
      var pegado = nombre.replace(/ /g, '');
      if (entero || (pegado.length >= 6 && compacto.indexOf(pegado) >= 0)) { r.personaje = personajes[nombre]; return true; }
      return false;
    });

    // Ocasión dicha con todas las letras.
    OCASIONES.some(function (o) {
      if (contiene(palabras, o.claves)) { r.ocasion = o; return true; }
      return false;
    });
    var esFiesta = !!(r.ocasion || r.personaje);

    // Negocio: gana si no hay señales claras de fiesta y aparece una palabra que solo es de negocio.
    var negocio = null, fuerte = false;
    if (!esFiesta) {
      var mejor = 0;
      NEGOCIOS.forEach(function (nq) {
        var claras = 0, todas = 0;
        nq.claves.forEach(function (c) {
          if (!contiene(palabras, [c])) return;
          todas++;
          if (AMBIGUAS.indexOf(c) < 0) claras++;
        });
        var valor = claras * 10 + todas;
        if (valor > mejor) { mejor = valor; negocio = nq; fuerte = claras > 0; }
      });
    }
    if (fuerte) { r.negocio = negocio; r.edad = null; return r; }

    // Temática: la del personaje, o la que se nombre directamente o por un sinónimo.
    if (r.personaje) { r.tema = r.personaje.tema; r.temaPedido = true; }
    if (!r.tema) {
      Object.keys(datos.nombres).some(function (slug) {
        var propias = normalizar(datos.nombres[slug]).split(' ').filter(function (p) { return p.length > 3 && SIN_SENTIDO.indexOf(p) < 0; });
        if (contiene(palabras, propias.concat(SINONIMOS[slug] || []))) { r.tema = slug; r.temaPedido = true; return true; }
        return false;
      });
    }

    // «15» es una fiesta de quince, salvo que ya se haya dicho otra ocasión.
    if (r.edad === 15 && (!r.ocasion || r.ocasion.id === 'cumple')) r.ocasion = OCASIONES[0];
    if (r.ocasion && r.ocasion.id === 'quince') r.edad = null;
    // Una temática con ocasión propia (egresados, románticos) la trae consigo.
    if (!r.ocasion && r.tema) {
      OCASIONES.some(function (o) { if (o.tema === r.tema) { r.ocasion = o; return true; } return false; });
    }
    // Con edad o con temática y sin más datos, es un cumpleaños.
    if (!r.ocasion && (r.tema || (r.edad && !negocio))) r.ocasion = OCASIONES[OCASIONES.length - 1];
    // Una ocasión con temática propia la usa para mostrar diseños, sin tratarla como pedido del cliente.
    if (r.ocasion && !r.tema && r.ocasion.tema) r.tema = r.ocasion.tema;

    if (!r.ocasion && negocio) { r.negocio = negocio; r.edad = null; }
    return r;
  }

  /* Productos que se recomiendan (hasta 3), con cuántos diseños de la temática tiene cada uno. */
  function recomendar(r, productos) {
    productos = productos || {};
    var hayCatalogo = Object.keys(productos).length > 0;
    var conteo = (r.tema && datos.conteo[r.tema]) || {};
    var base = r.negocio ? r.negocio.productos : (r.ocasion ? r.ocasion.productos : []);
    // Si el cliente nombró un producto («pasacalle», «roll up»), suma.
    var palabras = r.texto.split(' ').filter(function (p) { return p.length >= 4; }).map(raiz);
    // Una palabra que está en muchos títulos («cartel», «pasacalle») dice poco: pesa menos que una
    // que señala un producto puntual («roll», «vereda», «microperforado»).
    var titulos = {};
    Object.keys(productos).forEach(function (h) { titulos[h] = normalizar(productos[h].t).split(' ').map(raiz); });
    var enCuantos = {};
    palabras.forEach(function (p) {
      enCuantos[p] = Object.keys(titulos).filter(function (h) { return titulos[h].indexOf(p) >= 0; }).length;
    });
    var puntos = {};
    function sumar(h, n) { puntos[h] = (puntos[h] || 0) + n; }
    base.forEach(function (h, i) { sumar(h, 3 - i * 0.5); });
    Object.keys(titulos).forEach(function (h) {
      var mejor = 0;
      palabras.forEach(function (p) {
        if (titulos[h].indexOf(p) >= 0) mejor = Math.max(mejor, enCuantos[p] <= 3 ? 6 : 1.5);
      });
      if (mejor) sumar(h, mejor);
    });
    if (r.temaPedido) {
      Object.keys(conteo).forEach(function (h) { sumar(h, 3 + Math.min(conteo[h], 30) / 30); });
      // Pidió una temática y este producto no tiene diseños de eso: baja (igual se hace a medida).
      Object.keys(puntos).forEach(function (h) { if (!conteo[h]) sumar(h, -2); });
    }
    var orden = Object.keys(puntos)
      .filter(function (h) { return puntos[h] > 0 && (!hayCatalogo || productos[h]); })
      .sort(function (a, b) { return puntos[b] - puntos[a]; });
    var elegidos = orden.slice(0, 3);
    // El producto principal de la ocasión siempre está entre los tres, aunque no tenga diseños
    // de esa temática: se lo diseñamos igual.
    var principal = base[0];
    if (principal && elegidos.indexOf(principal) < 0 && (!hayCatalogo || productos[principal])) {
      elegidos = [principal].concat(elegidos.slice(0, 2));
    }
    return elegidos.map(function (h) { return { handle: h, disenos: conteo[h] || 0 }; });
  }

  /* Hasta `cuantos` diseños reales para mostrar: del personaje pedido o, si no, de la temática. */
  function disenosDe(r, cuantos) {
    if (!r.tema) return [];
    var claves = Object.keys(datos.disenos);
    var propios = r.personaje ? claves.filter(function (k) { return datos.disenos[k].p === r.personaje.nombre; }) : [];
    var delTema = claves.filter(function (k) { return propios.indexOf(k) < 0 && (datos.disenos[k].t || []).indexOf(r.tema) >= 0; });
    return propios.concat(delTema).slice(0, cuantos || 6);
  }

  function totalTema(slug) {
    var c = datos.conteo[slug] || {};
    return Object.keys(c).reduce(function (suma, h) { return suma + c[h]; }, 0);
  }

  return { normalizar: normalizar, interpretar: interpretar, recomendar: recomendar, disenosDe: disenosDe, totalTema: totalTema };
}

if (typeof module !== 'undefined' && module.exports) module.exports = tmBuscaNucleo;

(function () {
  if (typeof document === 'undefined' || window.tmBusca) return;
  window.tmBusca = true;

  var cfgTag = document.querySelector('script[data-tm-busca-config]');
  if (!cfgTag) return;
  var cfg = JSON.parse(cfgTag.textContent);
  var carga;

  function cargar() {
    if (!carga) {
      carga = Promise.all([
        fetch(cfg.temas).then(function (r) { return r.json(); }),
        fetch(cfg.productos).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); })
      ]).then(function (res) { return { nucleo: tmBuscaNucleo(res[0]), temas: res[0], productos: res[1].productos }; });
    }
    return carga;
  }

  function crear(etiqueta, clase, texto) {
    var el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto !== undefined) el.textContent = texto;
    return el;
  }
  function plata(centavos) { return '$' + Math.round(centavos / 100).toLocaleString('es-UY'); }
  function wa(mensaje) { return 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(mensaje); }

  function empujes(consulta) {
    var caja = crear('div', 'tb__empujes');
    var a = crear('a', 'tb__empuje tb__empuje--fuerte');
    a.href = wa('Hola! Busco: ' + consulta + '. No encontré el diseño que quiero, ¿me lo hacen a medida?');
    a.target = '_blank'; a.rel = 'noopener';
    a.appendChild(crear('strong', '', '¿No encontrás el que querés?'));
    a.appendChild(crear('span', '', 'No te preocupes: nuestro equipo te hace el diseño a medida, sin costo. Escribinos →'));
    caja.appendChild(a);
    // La web cobra el total: la seña se coordina por WhatsApp hasta que exista el pago parcial.
    var b = crear('a', 'tb__empuje');
    b.href = wa('Hola! Quiero empezar mi pedido con la seña del 50 %. Busco: ' + consulta);
    b.target = '_blank'; b.rel = 'noopener';
    b.appendChild(crear('strong', '', 'Empezás con una seña del 50 %'));
    b.appendChild(crear('span', '', 'El resto se acuerda con el diseño. Coordinala por WhatsApp →'));
    caja.appendChild(b);
    var c = crear('div', 'tb__empuje');
    c.appendChild(crear('strong', '', 'Pagalo en cuotas'));
    c.appendChild(crear('span', '', 'Con tarjeta, por Mercado Pago.'));
    caja.appendChild(c);
    return caja;
  }

  function pintar(panel, consulta, d, enResultados) {
    panel.textContent = '';
    var r = d.nucleo.interpretar(consulta);
    if (!r.texto) { panel.hidden = true; return; }
    panel.hidden = false;
    var entendio = r.ocasion || r.negocio || r.tema;
    var recomendados = d.nucleo.recomendar(r, d.productos);
    // En la página de búsqueda, si solo se nombró un producto, la lista de la tienda ya lo muestra abajo.
    if (enResultados && !entendio) recomendados = [];

    if (entendio || recomendados.length) {
      var fichas = crear('p', 'tb__entendido');
      fichas.appendChild(crear('span', 'tb__rotulo', 'Entendimos:'));
      if (r.ocasion) fichas.appendChild(crear('span', 'tb__ficha', r.ocasion.nombre));
      if (r.edad) fichas.appendChild(crear('span', 'tb__ficha', r.edad + (r.edad === 1 ? ' año' : ' años')));
      if (r.tema) fichas.appendChild(crear('span', 'tb__ficha', d.temas.nombres[r.tema]));
      if (r.negocio) fichas.appendChild(crear('span', 'tb__ficha', r.negocio.nombre));
      if (fichas.children.length > 1) panel.appendChild(fichas);
    }

    var disenos = d.nucleo.disenosDe(r, 6);
    if (disenos.length) {
      var total = d.nucleo.totalTema(r.tema);
      panel.appendChild(crear('p', 'tb__titulo', 'Diseños de ' + d.temas.nombres[r.tema] + ' que ya hicimos'));
      var tira = crear('div', 'tb__disenos');
      disenos.forEach(function (clave) {
        var enlace = crear('a', 'tb__diseno');
        enlace.href = cfg.selector + '?tema=' + encodeURIComponent(r.tema);
        var img = crear('img');
        img.src = 'https://cdn.shopify.com/s/files/' + clave + '?width=240';
        img.alt = 'Diseño de ' + d.temas.nombres[r.tema];
        img.loading = 'lazy'; img.width = 120; img.height = 120;
        enlace.appendChild(img);
        tira.appendChild(enlace);
      });
      panel.appendChild(tira);
      var todos = crear('a', 'tb__todos', 'Ver los ' + total + ' diseños de ' + d.temas.nombres[r.tema] + ' →');
      todos.href = cfg.selector + '?tema=' + encodeURIComponent(r.tema);
      panel.appendChild(todos);
    }

    if (recomendados.length) {
      panel.appendChild(crear('p', 'tb__titulo', r.negocio ? 'Para eso te sirve' : (entendio ? 'Lo más elegido para esto' : 'Esto es lo que tenemos')));
      var lista = crear('div', 'tb__productos');
      recomendados.forEach(function (rec) {
        var p = d.productos[rec.handle];
        var tarjeta = crear('a', 'tb__producto');
        tarjeta.href = p.u + (r.tema && rec.disenos ? '?tema=' + encodeURIComponent(r.tema) : '');
        if (p.i) {
          var foto = crear('img');
          foto.src = p.i; foto.alt = ''; foto.loading = 'lazy'; foto.width = 96; foto.height = 96;
          tarjeta.appendChild(foto);
        }
        var cuerpo = crear('span', 'tb__producto-texto');
        cuerpo.appendChild(crear('strong', '', p.t));
        cuerpo.appendChild(crear('span', 'tb__precio', (p.c ? 'A presupuesto' : 'Desde ' + plata(p.p))));
        if (rec.disenos) cuerpo.appendChild(crear('span', 'tb__cuenta', rec.disenos + (rec.disenos === 1 ? ' diseño' : ' diseños') + ' de ' + d.temas.nombres[r.tema]));
        else if (r.temaPedido) cuerpo.appendChild(crear('span', 'tb__cuenta', 'Te lo diseñamos con esa temática'));
        tarjeta.appendChild(cuerpo);
        lista.appendChild(tarjeta);
      });
      panel.appendChild(lista);
    } else if (!entendio && !enResultados) {
      panel.appendChild(crear('p', 'tb__titulo', 'No tenemos algo armado con ese nombre, pero lo hacemos'));
      panel.appendChild(crear('p', 'tb__texto', 'Todo lo que fabricamos es personalizado. Contanos la idea y te la diseñamos.'));
    }

    panel.appendChild(empujes(consulta));
  }

  function montar(form) {
    if (form.dataset.tbListo) return;
    form.dataset.tbListo = '1';
    var campo = form.querySelector('input[type="search"], input[type="text"]');
    var panel = form.parentElement.querySelector('[data-tm-busca-panel]');
    if (!campo || !panel) return;
    var espera;
    function actualizar() {
      var consulta = campo.value.trim();
      if (consulta.length < 3) { panel.hidden = true; panel.textContent = ''; return; }
      cargar().then(function (d) { if (campo.value.trim() === consulta) pintar(panel, consulta, d, form.hasAttribute('data-tm-busca-resultados')); })
        .catch(function () { panel.hidden = true; });
    }
    campo.addEventListener('focus', function () { cargar().catch(function () {}); }, { once: true });
    campo.addEventListener('input', function () { clearTimeout(espera); espera = setTimeout(actualizar, 180); });
    form.addEventListener('click', function (e) {
      var ejemplo = e.target.closest ? e.target.closest('[data-tm-busca-ejemplo]') : null;
      if (!ejemplo) return;
      e.preventDefault();
      campo.value = ejemplo.textContent.replace(/^[«"“]|[»"”]$/g, '').trim();
      actualizar();
      campo.focus();
    });
    // Enter no saca al cliente de la página si ya le estamos mostrando la respuesta.
    form.addEventListener('submit', function (e) {
      if (form.hasAttribute('data-tm-busca-quieto')) { e.preventDefault(); actualizar(); }
    });
    if (campo.value.trim().length >= 3) actualizar();
  }

  function iniciar() { document.querySelectorAll('form[data-tm-busca]').forEach(montar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
